export enum VerticalAlignment {
  Top = 'top',
  Bottom = 'bottom',
  Center = 'middle',
  None = 'none',
}
